import { Component, Injector, Input } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { LeadsService } from '../../shared/services/leads.service';

@Component({
	selector: 'lead-archive-dialog',
	templateUrl: './lead-archive-dialog.component.html',
	styleUrls: ['./lead-archive-dialog.component.scss'],
})
export class LeadArchiveDialogComponent {
	@Input() leadId: number;
	@Input() onSuccess: () => void;

	archiveComment = '';
	archiveCommentInvalid = false;

	constructor(
		private injector: Injector,
		private dataService: LeadsService
	) {}

	confirm(): void {
		if (!this.leadId) {
			this.close();
			return;
		}
		if (!this.archiveComment || !this.archiveComment.trim()) {
			this.archiveCommentInvalid = true;
			return;
		}
		this.archiveCommentInvalid = false;

		this.dataService.archive(this.leadId, this.archiveComment.trim()).subscribe(x => {
			if (x.isSuccessful) {
				this.archiveComment = '';
				if (this.onSuccess) {
					this.onSuccess();
				}
				this.close();
			}
		});
	}

	cancel(): void {
		this.close();
	}

	private close(): void {
		this.injector.get(DialogRef).close();
	}
}
